import ExcelJS from "exceljs";
import Money from "../helpers/utils/money/money";
import dateFormat from "dateformat";

export function exportJSONFile(datas, filename) {
  filename += ".json";
  let contentType = "application/json;charset=utf-8;";
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    var blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(datas)))], { type: contentType });
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    var a = document.createElement('a');
    a.download = filename;
    a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(datas));
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export function exportCSVFile(items, filename) {
  const headers = []

  Object.keys(items[0]).forEach(key => headers.push(key.toUpperCase()))

  items.unshift(headers)

  var jsonObject = JSON.stringify(items)

  var csv = convertToCSV(jsonObject)

  var exportedFilename = filename + '.csv'
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilename)
  } else {
    var link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

function convertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';

  for (var i = 0; i < array.length; i++) {
    var line = '';
    for (var index in array[i]) {
      if (line !== '') line += ';'

      line += array[i][index];
    }

    str += line + '\r\n';
  }

  return str;
}

export async function exportXlsx(items, columns, filename) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Dados');

  worksheet.addRow(columns.map(c => c.label.toUpperCase()));

  items.forEach(item => {
    const row = worksheet.addRow([]);
    
    columns.forEach((col, colIndex) => {
      const cell = row.getCell(colIndex + 1);
      
      try {
        let cellValue = '';
        const value = col.field === '{row}' ? item : item[col.field];

        if (col.isCurrency) {
          let currencyValue = col.formatExport
            ? col.formatExport(value)
            : value;
          const num = Number(currencyValue);
          cellValue = Number.isFinite(num)
            ? Money.centsToCoin(num)
            : 'N/I';
          cell.value = cellValue;
        }

        else if (col.isDate || col.isDateOnly) {
          const raw = value?.toDate ? value.toDate() : value;
          const date = raw ? new Date(raw) : null;

          if (date instanceof Date && !isNaN(date.getTime())) {
            const formatPattern = col.isDateOnly ? 'dd/mm/yyyy' : 'dd/mm/yyyy HH:MM';
            cellValue = dateFormat(date, formatPattern);
          } else {
            cellValue = 'N/I';
          }
          cell.value = cellValue;
          cell.numFmt = '@';
        }

        else if (col.isPercentage) {
          let percentValue = col.formatExport
            ? col.formatExport(value)
            : value;
          const num = Number(percentValue);
          cellValue = Number.isFinite(num)
            ? num
            : 'N/I';
          cell.value = cellValue;
        }

        else {
          let formattedValue = col.formatExport
            ? col.formatExport(value)
            : value;

          if (typeof formattedValue === 'string') {
            formattedValue = formattedValue.trim();
          }

          cellValue = formattedValue ?? 'N/I';
          
          if (cellValue === '' || cellValue === null || cellValue === undefined) {
            cellValue = 'N/I';
          }
          
          // Forçar como texto para números grandes (CPF, CEP, códigos, etc)
          // Para evitar notação científica
          if (typeof cellValue === 'string' && /^\d+$/.test(cellValue)) {
            cell.value = cellValue;
            cell.numFmt = '@';
          } else {
            cell.value = cellValue;
          }
        }

        if (col.wrapText) {
          cell.alignment = {
            ...(cell.alignment || {}),
            wrapText: true,
            vertical: 'top',
          };

          const lineCount = String(cellValue || '').split('\n').length;
          row.height = Math.max(row.height || 15, lineCount * 15);
        }
      } catch (error) {
        console.warn('Erro ao processar célula:', error);
        cell.value = 'N/I';
      }
    });
  });

  columns.forEach((colDef, index) => {
    const excelColumn = worksheet.getColumn(index + 1);

    if (colDef.width) {
      excelColumn.width = colDef.width;
    }

    if (colDef.isCurrency) {
      excelColumn.numFmt = 'R$ #,##0.00';
      excelColumn.width = colDef.width || 18;
    }

    else if (colDef.isDate || colDef.isDateOnly) {
      excelColumn.width = colDef.width || 18;
    }

    else if (colDef.isPercentage) {
      excelColumn.numFmt = '0.00%';
      excelColumn.width = colDef.width || 15;
    }

    else if (colDef.wrapText && !colDef.width) {
      excelColumn.width = 45;
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xlsx`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

